import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";

const rules = {
    email: ['required', 'email', 'valid_getjerry_email'],
    phone: 'valid_phone'
};

export const allFieldsValidation = (data) => {
    return allFieldsValidationCommon(data, rules, customErrorMessagesCommon);
};